import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', () => {
  const mainPageTitle = ref<string>("")

  const setPageTitle = (title: string) => {
    mainPageTitle.value = title;
  }

  return { mainPageTitle, setPageTitle }
})
